import { render, staticRenderFns } from "./EnterpriseAnnouncement.vue?vue&type=template&id=6c0c696e&scoped=true"
import script from "./EnterpriseAnnouncement.vue?vue&type=script&lang=js"
export * from "./EnterpriseAnnouncement.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EnterpriseAnnouncement.vue?vue&type=style&index=1&id=6c0c696e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c696e",
  null
  
)

export default component.exports